export const MAX_FILE_SIZE = 2097152
